export interface BusinessModel {
  id: number
  name: string
}

export default class Business {
  private constructor (
    readonly id: number,
    readonly name: string
  ) {

  }

  public static createFromModel (data: Partial<BusinessModel>): Business {
    return new Business(
      data.id!,
      data.name!
    );
  }
}